export default __webpack_public_path__ + "static/media/aws-2.aea392d5.svg";